<script lang="ts">
	import { t } from 'svelte-i18n';

	export let totalScore: string = '';
</script>

{#if totalScore && totalScore.length}
	<div
		class="flex justify-between items-center
            bg-decision-tool-{totalScore}-light text-decision-tool-{totalScore}
            rounded-md px-4 py-3
            text-3xl font-bold"
	>
		<div>{$t('decisionTool.totalScore')}</div>
		<div>{totalScore}</div>
	</div>
{/if}
